import { Typography, Button, Paper } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toSurveyMain } from '../../utils/routes';
import { useTranslation } from 'react-i18next';

export default function WelcomeSurvey(props) {

    const {t} = useTranslation()

    const navigate = useNavigate();

    const startSurvey = () => {
        props.startSurvey();
        navigate(toSurveyMain);
    }

    return(
        <Paper sx={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "start", p: 2}}>
            <Typography align="left" sx={{width: "100%"}}>{t("welcome", {website: "Gekonnt hanDeln"})}</Typography>
            <Typography align="left" sx={{mt: 2}}>
                {t("surveyWelcomeText1")}
            </Typography>
            <Typography align="left" sx={{mt: 2}}>{t("surveyWelcomeText2")}</Typography>
            <Button onClick={startSurvey} sx={{mt: 2}} variant="contained" color="primary">{t("surveyWelcomeButton")}</Button>
        </Paper>
    )
}